var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("音频组件，只需要传入音频路径src，props名称为AudioSrc")]),_c('Audio')],1)}
var staticRenderFns = []

export { render, staticRenderFns }